<template>
  <div class="contact-form-component">
    <div class="box">
      <div class="columns">
        <div class="column is-6">
          <form action="https://formspree.io/info@crowdflik.com" method="POST">
            <b-field label="Return Email Address" aria-required required>
              <b-input
                v-model="email"
                placeholder="Enter your email address."
                type="email"
                name="email"
              ></b-input>
            </b-field>
            <b-field label="Subject" aria-required required>
              <b-input
                v-model="subject"
                placeholder="What would you like to chat about?"
                type="text"
                name="subject"
              ></b-input>
            </b-field>
            <b-field label="Message">
              <b-input
                maxlength="200"
                v-model="message"
                type="textarea"
                name="message"
                placeholder="Write your message here."
              ></b-input>
            </b-field>
            <input
              class="button is-fullwidth"
              v-bind:class="buttonClass"
              type="submit"
              value="Send"
            />
          </form>
        </div>
        <div class="column">
          <div class="mapouter">
            <div class="gmap_canvas">
              <iframe
                width="800"
                height="500"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=22%20Ketchum%20Street%2C%20Westport%20CT%2006880&t=&z=15&ie=UTF8&iwloc=&output=embed"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
              ></iframe>
            </div>
          </div>
          <div class="columns has-margin-top-5">
            <!-- left nested column -->
            <div class="column">
              <div class="level is-mobile">
                <div class="level-left">
                  <div class="level-item">
                    <b-icon icon="map-marker" type="is-primary"></b-icon>
                  </div>
                  <div class="level-item">
                    <p class="is-size-6">
                      22 Ketchum Street<br />Westport, CT 06880
                    </p>
                  </div>
                </div>
              </div>
              <div class="level is-mobile">
                <div class="level-left">
                  <div class="level-item">
                    <b-icon icon="phone" type="is-success"></b-icon>
                  </div>
                  <p class="subtitle is-size-6">+1 (929) 400-3545</p>
                </div>
              </div>
            </div>
            <!-- right nested column -->
            <div class="column">
              <p class="is-size-6">
                For press/media inquiries, please contact
                <a href="mailto:info@crowdflik.com">info@crowdflik.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactFormComponent",
  data() {
    return {
      email: null,
      subject: null,
      message: null
    };
  },
  computed: {
    buttonClass: function() {
      if (this.email && this.subject && this.message) {
        return {
          "is-static": false,
          "is-success": true
        };
      } else {
        return {
          "is-static": true,
          "is-success": false
        };
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
